<template>
	<div class="layout-menu-wrapper" :class="{'layout-sidebar-active': sidebarActive}"
		@click="onMenuClick" @mouseover="onSidebarMouseOver" @mouseleave="onSidebarMouseLeave">
		<div class="menu-logo">

			<a href="#" class="logo">
				<img :src="'layout/images/logo-'+ (colorScheme === 'light' ? 'dark' : 'light') + '.png'">
			</a>

			<!-- <a href="#" class="app-name">
				<img :src="'layout/images/appname-'+ (colorScheme === 'light' ? 'dark' : 'light') + '.png'"/>
			</a> -->
			<a href="#" class="menu-pin" @click="onToggleMenu">
				<span v-if="isOverlay()" class="pi pi-times"></span>
				<span v-if="isSidebar() && !sidebarStatic && pinActive" class="pi pi-unlock"></span>
				<span v-if="isSidebar() && sidebarStatic && pinActive" class="pi pi-lock"></span>
		</a>
	</div>

	<div class="layout-menu-search" :class="{'search-collapsed': !searchExpanded && isMobile()}">
		<Button 
			v-if="isMobile()" 
			icon="pi pi-search" 
			class="p-button-text search-toggle-btn" 
			@click="toggleSearch"
			:class="{'active': searchExpanded}"
			aria-label="Mostra/Nascondi ricerca"
		/>
		<div v-show="searchExpanded || !isMobile()" class="search-input-wrapper">
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<InputText 
					v-model="searchQuery" 
					:placeholder="isMobile() ? 'Cerca...' : 'Cerca nel menu...'" 
					@input="onSearchInput"
					class="w-full" 
					ref="searchInput"
				/>
			</span>
			<Button 
				v-if="searchQuery" 
				icon="pi pi-times" 
				class="p-button-text clear-search-btn" 
				:class="{'mobile-clear': isMobile()}"
				@click="clearSearch"
				:aria-label="'Pulisci ricerca'"
			/>
		</div>
	</div>

	<div class="layout-menu-container">
		<AppSubmenu class="layout-menu" :items="filteredModel" :menuMode="menuMode" :menuActive="menuActive" :root="true" :parentMenuItemActive="true"
			:searchQuery="searchQuery" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"/>
	</div>		<AppInlineMenu :menuMode="menuMode" :activeInlineProfile="activeInlineProfile" @change-inlinemenu="onChangeActiveInlineMenu"></AppInlineMenu>
	</div>
</template>

<script>
import AppSubmenu from './AppSubmenu';
import AppInlineMenu from './AppInlineMenu';

export default {
	name: 'AppMenu',
	emits: ['menu-click', 'menuitem-click', 'root-menuitem-click', 'sidebar-mouse-over', 'sidebar-mouse-leave', 'toggle-menu', 'change-inlinemenu'],
	props: {
		model: Array,
		menuMode: String,
		colorScheme: String,
		menuActive: {
            type: Boolean,
            default: false
        },
		activeInlineProfile: {
			type: Boolean,
			default: false
		},
		sidebarActive: {
			type: Boolean,
			default: false
		},
		sidebarStatic: {
			type: Boolean,
			default: false
		},
		pinActive: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			searchQuery: '',
			filteredModel: [],
			searchExpanded: false
		}
	},
	components: {
		AppSubmenu,
		AppInlineMenu
	},
	watch: {
		model: {
			immediate: true,
			handler(newVal) {
				this.filteredModel = newVal || [];
			}
		}
	},
	methods: {
		onSearchInput() {
			if (!this.searchQuery || this.searchQuery.trim() === '') {
				this.filteredModel = this.model;
				return;
			}
			
			const query = this.searchQuery.toLowerCase().trim();
			this.filteredModel = this.filterMenuItems(this.model, query);
		},
		
		filterMenuItems(items, query) {
			if (!items) return [];
			
			const filtered = [];
			
			for (const item of items) {
				// Controlla se l'etichetta dell'item corrente corrisponde alla query
				const labelMatch = item.label && item.label.toLowerCase().includes(query);
				
				// Se ha sottomenu, filtro ricorsivamente
				if (item.items && item.items.length > 0) {
					const filteredChildren = this.filterMenuItems(item.items, query);
					
					// Includo l'item se:
					// 1. La sua label corrisponde, OPPURE
					// 2. Ha figli che corrispondono
					if (labelMatch || filteredChildren.length > 0) {
						filtered.push({
							...item,
							items: filteredChildren.length > 0 ? filteredChildren : item.items
						});
					}
				} else {
					// Item senza figli: includo solo se la label corrisponde
					if (labelMatch) {
						filtered.push({ ...item });
					}
				}
			}
			
			return filtered;
		},
		
		clearSearch() {
			this.searchQuery = '';
			this.filteredModel = this.model;
			if (this.isMobile()) {
				this.searchExpanded = false;
			}
		},
		
		toggleSearch() {
			this.searchExpanded = !this.searchExpanded;
			if (this.searchExpanded) {
				this.$nextTick(() => {
					if (this.$refs.searchInput) {
						this.$refs.searchInput.$el.focus();
					}
				});
			}
		},
		
		onSidebarMouseOver() {
            this.$emit('sidebar-mouse-over');
        },
        onSidebarMouseLeave() {
            this.$emit('sidebar-mouse-leave');
        },
		onMenuClick(event) {
            this.$emit('menu-click', event);
        },
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
		onRootMenuItemClick(event) {
			this.$emit('root-menuitem-click', event);
		},
		onToggleMenu(event) {
            this.$emit('toggle-menu', event);
        },
		onChangeActiveInlineMenu() {
			this.$emit('change-inlinemenu');
		},
		isHorizontal() {
			return this.menuMode === 'horizontal';
		},
		isSlim() {
			return this.menuMode === 'slim';
		},
		isOverlay() {
			return this.menuMode === 'overlay';
		},
		isStatic() {
			return this.menuMode === 'static';
		},
		isSidebar() {
			return this.menuMode === 'sidebar';
		},
		isDesktop() {
			return window.innerWidth > 991;
		},
		isMobile() {
			return window.innerWidth <= 991;
		}
	}
}
</script>

<style scoped>
.layout-menu-search {
	padding: 1rem;
	position: relative;
	background: inherit;
	z-index: 10;
}

/* Sticky search on mobile */
@media (max-width: 991px) {
	.layout-menu-search {
		position: sticky;
		top: 0;
		background: var(--surface-overlay);
		border-bottom: 1px solid var(--surface-border);
		padding: 0.75rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}
	
	.layout-menu-search.search-collapsed {
		padding: 0.5rem;
	}
}

.search-input-wrapper {
	position: relative;
	flex: 1;
}

.layout-menu-search .p-input-icon-left {
	width: 100%;
}

.layout-menu-search .p-inputtext {
	width: 100%;
	padding-right: 2.5rem;
}

.clear-search-btn {
	position: absolute;
	right: 0.25rem;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	min-width: auto;
	height: auto;
	padding: 0.5rem;
}

/* Touch-friendly button size on mobile */
@media (max-width: 991px) {
	.clear-search-btn.mobile-clear {
		padding: 0.75rem;
		min-width: 2.5rem;
		height: 2.5rem;
	}
	
	.search-toggle-btn {
		min-width: 2.5rem;
		height: 2.5rem;
		padding: 0.75rem;
	}
	
	.search-toggle-btn.active {
		background: var(--primary-color);
		color: var(--primary-color-text);
	}
	
	.layout-menu-search .p-inputtext {
		font-size: 1rem;
		padding: 0.75rem 3rem 0.75rem 2.5rem;
		height: 2.75rem;
	}
	
	.layout-menu-search .p-input-icon-left > i:first-of-type {
		left: 0.75rem;
	}
}

/* Smooth transitions */
.search-input-wrapper {
	transition: all 0.3s ease;
}

/* Better tap feedback */
@media (max-width: 991px) {
	.layout-menu-search .p-button {
		transition: transform 0.1s ease;
	}
	
	.layout-menu-search .p-button:active {
		transform: scale(0.95);
	}
}
</style>